import { PRODUCT } from '@components/in-app-purchase/in-app-purchase.enum';
import { AssistantSubscriptionPlanItem } from './list-plan.interface';

export const PLANS: Array<AssistantSubscriptionPlanItem> = [
  {
    id: 'asax_assistant_1_year',
    storeProductId: {
      regular: PRODUCT.SUBSCRIBE_ASAX_ASSISTANT_1_YEAR,
      unlock: ''
    },
    title: `
    Exclusive Offer: Get 18 Months for the Price of 12!
<span style="background: linear-gradient(180deg, #3D7BD5 0%, #204272 100%); background-clip: text; -webkit-background-clip: text; -webkit-text-fill-color: transparent;">1-Year Subscription + 6 Months FREE</span>
    `,
    desc: 'Enjoy 18 months of AsaX Assistant, billed annually',
    price: 1200000,
    priceCurrency: 'IDR',
    tags: [
      {
        id: 'best-plan',
        title: 'BEST PLAN',
        cssStyles: [
          'background: linear-gradient(90deg, #1D7DDC 0%, #104376 100%); color: white;'
        ]
      },
      {
        id: 'save-75%',
        title: 'Save 75%',
        cssStyles: ['background: #F67D62; color: white;']
      }
    ],
    planIncludes: [
      {
        desc: 'Unlimited AI-Powered Health Consultations'
      },
      {
        desc: 'Priority Response Times for faster insights'
      },
      {
        desc: 'In-Depth Analysis of your genetics, lifestyle & wellness profile'
      },
      {
        desc: 'Photo & Voice Input Features (Coming Soon) — for smarter, more personalized support'
      }
    ]
  },
  {
    id: 'asax_assistant_360_dna',
    storeProductId: {
      regular: PRODUCT.PURCHASE_ASAX_ASSISTANT_360_DNA,
      unlock: PRODUCT.UNLOCK_ASAX_ASSISTANT_360_DNA
    },
    title: `Buy 360 DNA → <span style="background: linear-gradient(180deg, #3D7BD5 0%, #204272 100%); background-clip: text; -webkit-background-clip: text; -webkit-text-fill-color: transparent;">Get 1 Month FREE</span>`,
    desc: `Unlock 360 DNA report and enjoy 1 month of AsaX Assistant`,
    tags: [],
    planIncludes: [
      {
        desc: 'Exclusive 1 Month Free Premium AsaX Assistant Access'
      },
      {
        desc: '24/7 Virtual Consultation Support'
      },
      {
        desc: 'Get 300+ Comprehensive DNA Reports'
      },
      {
        desc: '⁠Personalized Fitness, Nutrition, and Wellness Insights Tailored to Your Genetics'
      }
    ],
    price: 2500000,
    priceCurrency: 'IDR'
  },
  {
    id: 'asax_assistant_3_month',
    storeProductId: {
      regular: PRODUCT.SUBSCRIBE_ASAX_ASSISTANT_3_MONTHS,
      unlock: ''
    },
    title: `3 Month Subscription Plan`,
    desc: `Enjoy 3 months of AsaX Assistant Plus, billed quarterly`,
    tags: [
      {
        id: 'save-15%',
        title: 'Save 15%',
        cssStyles: ['background: #F67D62; color: white;']
      }
    ],
    planIncludes: [
      {
        desc: 'Unlimited AI Health Consultations'
      },
      {
        desc: 'Anything ⁠in Freemium'
      },
      {
        desc: 'Extended Limits On Messaging, File Uploads, Data Anlysis and Image Generation (Coming Soon)'
      }
    ],
    price: 500000,
    priceCurrency: 'IDR'
  }
];
